const OPENING_DAYS = [
    {
        id: 'monday',
        label: 'Montag',
    },
    {
        id: 'tuesday',
        label: 'Dienstag',
    },
    {
        id: 'wednesday',
        label: 'Mittwoch',
    },
    {
        id: 'thursday',
        label: 'Donnerstag',
    },
    {
        id: 'friday',
        label: 'Freitag',
    },
    {
        id: 'saturday',
        label: 'Samstag',
    },
    {
        id: 'sunday',
        label: 'Sonntag',
    },
];

const DURATION_LABELS = {
    day: {
        short: 'd',
        long: ['Tag', 'Tage']
    },
    hour: {
        short: 'h',
        long: ['Stunde', 'Stunden']
    },
    minute: {
        short: 'min',
        long: ['Minute', 'Minuten']
    },
}

const CURRENCY_SYMBOLS = {
    CZK: 'Kč',
    EUR: '€',
    HRK: 'kn',
    GBP: '£',
    USD: '$',
    NOK: 'nkr',
    HUF: 'Ft',
}

export function formatDate(date) {
    return date.toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' })
}

export function getDayName(date) {
    return date.toLocaleDateString('de-DE', { weekday: 'long' });
}

export function formatTime(date) {
    return date.toLocaleTimeString('de-AT', {hour: '2-digit', minute:'2-digit'})
}

export function formatTimeFromTimestamp(timestamp) {
    let datetime = new Date(timestamp);
    let hours = ('0' + datetime.getHours()).slice(-2);
    var minutes = ('0' + datetime.getMinutes()).slice(-2);
    return `${hours}:${minutes}`;
}

export function formatDateFromTimestamp(timestamp) {
    let datetime = new Date(timestamp)
    return formatDate(datetime)
}

export function formatDuration(duration, addSpaces = true, showZeroMin = false, version = 'short') {
    let seconds = parseInt(duration)
    let days = Math.floor(seconds / (3600 * 24));
    seconds  -= days * 3600 * 24;
    let hours   = Math.floor(seconds / 3600);
    seconds  -= hours * 3600;
    let minutes = Math.floor(seconds / 60);
    seconds  -= minutes * 60;
    let dayLabel = DURATION_LABELS.day[version]
    let hourLabel = DURATION_LABELS.hour[version]
    let minuteLabel = DURATION_LABELS.minute[version]
    if(version === 'long') {
        dayLabel = days === 1 ? dayLabel[0] : dayLabel[1]
        hourLabel = hours === 1 ? hourLabel[0] : hourLabel[1]
        minuteLabel = minutes === 1 ? minuteLabel[0] : minuteLabel[1]
    }
    return (days > 0 ? `${days}${addSpaces ? ' ' : ''}${dayLabel} ` : '') + (hours > 0 ? `${hours}${addSpaces ? ' ' : ''}${hourLabel} ` : '') + (minutes > 0 || showZeroMin ? `${minutes}${addSpaces ? ' ' : ''}${minuteLabel}` : '')
}

export function formatDurationToMinutes(duration) {
    let seconds = parseInt(duration)
    let minutes = Math.floor(seconds / 60);
    return minutes
}

export function formatDistance(distance) {
    // 0 - 1km -> meters without decimal point
    // 1 - 10km -> km with decimal point
    // 10 - ∞km -> km without decimal point
    if(!distance) return false;

    const m = parseInt(distance)
    if(m < 1000) return `${m} m`

    const km = m / 1000
    let kmString = km < 10 ? `${Math.round(km * 10) / 10} km` : `${Math.floor(km)} km`
    kmString = kmString.replace('.', ',')
    return kmString
}

export function formatDistanceToKm(distance, isKm = false, showMeter = false) {
    if(!distance && distance !== 0) return false;
    let km
    if(isKm) {
        km = parseInt(distance)
        if(showMeter && distance < 1) {
            return (parseInt(distance * 1000)).toString() + ' m'
        }
    } else {
        const m = parseInt(distance)
        km = m / 1000
    }
    km = Math.round(km * 10) / 10
    return km.toString().replace('.', ',') + ' km'
}

export function formatPrice(price, includeCurrency = true, afterComma = 2, currency = '€') {
    let result = '';
    if(includeCurrency) {
        const currencySymbol = CURRENCY_SYMBOLS[currency] || currency
        result += `${currencySymbol || '€'} `;
    }
    result += price.toFixed(afterComma);
    return result.replace('.', ',');
}

export function formatOpeningHours(hours) {
    let formatted = [];
    OPENING_DAYS.forEach(openingDay => {
        const day = hours[openingDay.id];
        let dayObject;
        if(day) {
            dayObject = {
                label: openingDay.label,
                hours: formatDayHours(day),
            }
        } else {
            dayObject = {
                label: openingDay.label,
                hours: false,
            }
        }
        formatted.push(dayObject);
    })
    if(!formatted.length) return false;

    let merged = [];
    let startDay = formatted[0].label;
    formatted.forEach((formattedItem, formattedIndex) => {
        const nextDay = formatted[formattedIndex + 1];
        if(!nextDay || formattedItem.hours.toString() !== nextDay.hours.toString()) {
            const label = startDay === formattedItem.label ? startDay : `${startDay} – ${formattedItem.label}`;
            let itemObject = {
                label,
                hours: formattedItem.hours
            }
            
            if(formattedItem.hours) {
                merged.push(itemObject);
            }
            if(nextDay) {
                startDay = nextDay.label;
            }
        }
    })
    return merged;
}

export function formatDayHours(day) {
    return day.map(dayItem => {
        return formatHoursString(dayItem);
    })
}

export function formatTodayOpeningHours(hours) {
    if(!hours) return false;
    const today = getTodayFromOpeningHours(hours)
    if(!today) return {label: 'heute geschlossen'};
    let openingHours = formatDayHours(today.hoursItem);
    return {
        label: today.label.substring(0,2).toUpperCase(),
        hours: openingHours
    };
}

export function getTodayFromOpeningHours(hours) {
    var day = getTodaysDayMondayFirst();
    var hoursItem = hours[OPENING_DAYS[day].id];
    if(hoursItem) {
        return {
            label: OPENING_DAYS[day].label,
            hoursItem
        }
    } else {
        return false;
    }
}

export function formatHoursString(hours) {
    let from = hours.from.substring(0, 5);
    let to = hours.to.substring(0, 5);
    return `${from} – ${to}`;
}

export function formatTimeAgo(timestamp) {
    if(!timestamp) return false
    const now = new Date()
    const past = new Date(timestamp)
    const differenceMilliseconds =  Math.abs(now - past)
    const differenceSeconds = differenceMilliseconds / 1000
    return formatDuration(differenceSeconds, true);
}

export function formatUrl(url) {
    let formattedUrl = url
    if(url.includes('www')) {
        formattedUrl = url.substring(url.indexOf('www'))
    }
    if(url.includes('/')) {
        if(url.includes('://')) {
            const splitUrl = formattedUrl.split('://')
            formattedUrl = splitUrl.length > 1 ? splitUrl[1].split('/')[0] : splitUrl[0].split('/')[0]
        } else {
            formattedUrl = formattedUrl.split('/')[0]
        }
    }
    return formattedUrl
}

export function formatHeight(height) {
    const formattedHeight = height.toFixed(2)
    return `${formattedHeight.replace('.', ',')} m`
}

export function formatOpeningSeason(season) {
    return `${season.from} - ${season.to}`
}

function getTodaysDayMondayFirst() {
    const today = new Date()
    return (today.getDay() + 6) % 7;
}

export function capitalize(s) {
    return s && s[0].toUpperCase() + s.slice(1);
}

export function decapitalize(s) {
    return s && s[0].toLowerCase() + s.slice(1);
}

export function hexToBase64(str) {
    return btoa(String.fromCharCode.apply(null, str.replace(/\r|\n/g, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" ")));
}

export function fixUrl(url) {
    if(!url.includes('http')) {
        return `https://${url}`
    }
}

export function formatFloatWithComma(val) {
    return `${val}`.replace('.', ',')
}

export async function parseJwt(token) {
    try {
      return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
      return null;
    }
}

export function calculateGasPrice(consumption, price, distance) { // distance in m
    const distanceInKm = distance / 1000
    const gasPrice = (consumption * price * distanceInKm) / 100
    return formatPrice(gasPrice)
}

export function calculateGasConsumption(consumption, distance) { // distance in m
    const distanceInKm = distance / 1000
    let gasConsumption = (consumption * distanceInKm) / 100
    gasConsumption = gasConsumption.toFixed(2)
    return formatFloatWithComma(gasConsumption)
}